import { tilesNow } from "../sim/player";
import type { WorldState } from "../sim/types";

export const VIEW_SCALE = 2.15;
const TS = 32;

export interface Cam {
  x: number;
  y: number;
}

export function createCam(): Cam {
  return { x: 0, y: 0 };
}

/** Keep the viewport over authored tiles, not the void. */
export function boundCamTarget(
  tx: number,
  ty: number,
  mapW: number,
  mapH: number,
  viewW: number,
  viewH: number,
): { x: number; y: number } {
  const halfW = viewW / (2 * VIEW_SCALE * TS);
  const halfH = viewH / (2 * VIEW_SCALE * TS);
  if (mapW <= halfW * 2) tx = mapW / 2;
  else tx = Math.max(halfW, Math.min(mapW - halfW, tx));
  if (mapH <= halfH * 2) ty = mapH / 2;
  else ty = Math.max(halfH, Math.min(mapH - halfH, ty));
  return { x: tx, y: ty };
}

export function tickCam(cam: Cam, w: WorldState, dt: number, viewW = 1280, viewH = 720): void {
  const look = 0.55;
  let tx = w.player.x + w.player.vx * look + w.player.facing.x * 2.1;
  let ty = w.player.y + w.player.vy * look + w.player.facing.y * 2.1;
  const map = tilesNow(w);
  ({ x: tx, y: ty } = boundCamTarget(tx, ty, map.w, map.h, viewW, viewH));
  const k = 1 - Math.exp(-8 * dt);
  cam.x += (tx - cam.x) * k;
  cam.y += (ty - cam.y) * k;
}

export function shakeCam(cam: Cam, w: WorldState): { x: number; y: number } {
  if (w.shake <= 0) return cam;
  const a = w.shake * 0.18;
  return { x: cam.x + (Math.random() - 0.5) * a, y: cam.y + (Math.random() - 0.5) * a };
}
